import { render, staticRenderFns } from "./ConfiguratorCategoryContainer.vue?vue&type=template&id=a72a0960&scoped=true&"
import script from "./ConfiguratorCategoryContainer.vue?vue&type=script&lang=ts&"
export * from "./ConfiguratorCategoryContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ConfiguratorCategoryContainer.vue?vue&type=style&index=0&id=a72a0960&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72a0960",
  null
  
)

export default component.exports